// extracted by mini-css-extract-plugin
export default {"wrapper":"EjZhe3TsH3IyE49lGhFg5w==","error":"QYmLKe-GD2NGTrk5wFW-2Q==","postErrorWrapper":"fxpvT38RuDYWkMdLJP+yKw=="};